import React from "react";
import InputField from "../reusableComponents/InputField";
import UserStore from "../../stores/UserStore";
import { Link } from "react-router-dom";
import { DropdownList, Multiselect } from "react-widgets";
import Can from "../../components/authentication/Can";

class UserDataDisplayForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: props.user,
      buttonDisabled: false,
    };
  }

  async componentDidMount() {
    this.getPermissions();
  }

  async getPermissions() {
    if (!UserStore.isLoggedIn || !UserStore.username) {
      return;
    }
    try {
      let res = await fetch("/getPermissions", {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      let result = await res.json();
      if (result && result.success) {
        this.setState({
          roles: result.permissions,
        });
      } else if (result && result.success === false) {
      }
    } catch (e) {
      console.log(e);
    }
  }

  handleKeyDown(e) {
    if (e.key === "Enter") {
      this.doLogin();
    }
  }

  render() {
    return (
      <>
        <div className="transparent box wide center">
          <h3>Your Details:</h3>
          <div className="grid2by2">
            <span>First Name:</span>
            <span>Last Name:</span>
            <InputField
              type="text"
              disabled="true"
              placeholder="First Name"
              value={this.state.user.first_name ? this.state.user.first_name : ""}
            />
            <InputField
              type="text"
              disabled="true"
              placeholder="Last Name"
              value={this.state.user.last_name ? this.state.user.last_name : ""}
            />
            <span>Email:</span>
            <span>Phone Number:</span>
            <InputField
              type="text"
              disabled="true"
              placeholder="Email"
              value={this.state.user.email ? this.state.user.email : ""}
            />
            <InputField
              type="text"
              disabled="true"
              placeholder="Phone Number"
              value={this.state.user.phone ? this.state.user.phone :"No Phone Number Assigned" }
            />
          </div>
          <Link to="/forgot">
            <div className="hyper-link">Send Password Reset</div>
          </Link>          
        </div>
      </>
    );
  }
}

export default UserDataDisplayForm;
